export const AWARDS_SELECT_VALUE_ALL = 'all';
export const AWARDS_SELECT_VALUE_MULTI = 'multi';
